import { render, staticRenderFns } from "./OptionValueEdit.vue?vue&type=template&id=0cfaa04c"
import script from "./OptionValueEdit.vue?vue&type=script&lang=js"
export * from "./OptionValueEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports